/**
 * ERP Settings Service
 *
 * Cliente HTTP para configurações parametrizáveis do ERP.
 */

import api from './api'

export const erpSettingsService = {
  listNamespaces: async () => {
    const response = await api.get('/api/settings/erp')
    return response.data
  },

  getNamespace: async (namespace) => {
    const response = await api.get(`/api/settings/erp/${namespace}`)
    return response.data
  },

  updateNamespace: async (namespace, settings) => {
    const response = await api.put(`/api/settings/erp/${namespace}`, { settings })
    return response.data
  },

  uploadStorefrontBanner: async (file) => {
    const formData = new FormData()
    formData.append('image', file)
    const response = await api.post('/api/settings/storefront/upload-banner', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
  },

  getPublicStorefront: async () => {
    const response = await api.get('/api/public/storefront')
    return response.data
  },
}

